import { WorkflowStatusName } from "./WorkflowStatusName";
import { WorkflowOperation } from "./WorkflowOperation";
import { DocumentSummaryHistory } from "../../../domain/document";

// 依頼実施履歴model
export class ReceptionOperation {

  // 対応するWFステータス: wf履歴以外はnull
  public correspondStatus: WorkflowStatusName;

  // 実施情報
  public operation: WorkflowOperation;

  // コメント内容（伝達事項もここに入る）
  public commentContent: string;

  // 書類履歴ID（WF履歴の場合に入る）
  public documentArchive: DocumentSummaryHistory;
}
